import {TimeInterval} from '../Enums/Enum';
import {contextHelpIds} from './ContextHelpIds';
import {documentCategories} from './DocumentCategories';
import {Connection} from 'InstanceFactory';

const constants = {
    documentCategories,
    newline: '\r\n',
    expectedTestSessionId: 'c8c843cc-3b30-4efb-9711-ff83c8708b25',
    defaultLocale: 'en-us',
    knowledgeBaseUrl: 'http://s1.altosoft.com/knowledge/',
    applicationName: strings.applicationName,
    noFilterId: '{CD682E98-70B2-4CC4-B68D-D3D421E24F43}',
    defaultDatabaseServerDocumentId: '0bc5b476-7399-b40b-d8c8-c3023b526a09',
    doNotExecuteInParallelWithAllPlans: 'f9030d69-6e72-4141-a3c9-1dc403a6eb55',
    dataSeriesDrillDownId: 'DataSeries',
    metricNameDrillDownId: 'Metric Name',
    dataSeriesDrillDownName: strings.dataSeriesDrillDownName,
    totalName: strings.totalName,
    totalRowId: '8627FF9479984391BAB2772F22F46601',
    otherRowId: 'ea0f98bd-d660-4481-9478-6a551eef835d',
    specialOtherRowId: '10ed3cbd-2c01-4ada-a5a2-21a0c4c50cb9',
    chartTotalRowId: '03a5fce3-e03a-4343-aed2-cc1fba0cf0f8',
    parentComponentAnchorId: 'f4b026ec-761e-4d08-b2d7-be5305baeee9',
    /*** @deprecated use Guid.empty */
    guidEmpty: '00000000-0000-0000-0000-000000000000',
    maxChartResults: 5000,
    invariantCultureDateTimeFormat: 'MM"/"dd"/"yyyy HH:mm:ss',
    invariantCultureDateFormat: 'MM"/"dd"/"yyyy',
    invariantCultureTimeFormat: 'HH:mm:ss',
    defaultTimeSpanFormat: 'hh:mm:ss',
    dayTimeSpanFormat: 'dd.hh:mm:ss',
    defaultTimeFormat: 'HH:mm',
    defaultDateTimeFormat: 'MM/dd/yyyy hh:mm:ss tt',
    defaultDateFormat: 'MM/dd/yyyy',
    defaultNumberFormat: '#,##0.00',
    defaultPercentageFormat: '#,##0%',
    defaultNamedFormatName: 'Full',
    defaultDateFormatName: 'Date',
    defaultDateWithTimeFormatName: 'Date, with time',
    dateTimeFilterName: 'Global DateTime' as 'Global DateTime',
    aggregationFilterName: 'Global Aggregation',
    touchHoldTime: 500,
    touchMoveTitleLength: 100,
    touchMoveViewHolderLength: 20,
    animationSpeed: 1000,
    mapRadiusFactor: 100000,
    defaultStringLength: 50,
    maxStringLength: 4000,
    embededDocumentId: '{ED8A15E5-BC09-4921-99AB-3EFA25EDCAC9}',

    defaultThemeId: '8ae63255-f5f4-41d9-962c-af952443ac75',
    noAuthRoleId: '605aa8e1-48a2-46dd-98d3-07fd8ec66fd9',

    get imagesPath(): string {
        return altosoft.rootPath + 'Images/';
    },
    get resourcesPath(): string {
        return altosoft.rootPath + 'build/';
    },

    gridCellIconsImagesPath: 'GridCellIcons/',

    spinnerSize: 44,
    spinnerDelay: 500,

    defaultDBTemplateName: 'Default DBMS Template',

    userPropertyNames: {
        displayName: 'DisplayName',
        login: 'Login',
        financialYearStart: 'FinancialYearStart'
    },
    userPropertyPrefix: 'UserProperty',

    splitterSize: 5,

    nearestPointsThreshold: 25,

    stepIndexFilterName: 'StepIndex',
    processPathFilterName: 'Process filter',

    autoScrollDelay: 100,
    autoScrollStep: 20,
    autoScrollGap: 20,

    defaultHost: 'localhost',
    defaultPort: 80,
    HTTPSPort: 443,
    defaultHTTPS: false,
    dataServicePath: 'WcfDataService2',
    documentsPath: '../Documents',

    ttNameAttribute: 'Name',

    isOnLine: true,
    updateDataAutomatically: false,
    updateInterval: 1,
    updateIntervalType: 'day',

    defaultSizeDelta: 100,

    sessionIdParameter: 'SessionId',
    projectIdParameter: 'ProjectId',
    reportIdParameter: 'ReportId',
    reportExtensionParameter: 'Ext',
    reportFileNameParameter: 'FileName',
    projectNameParameter: 'ProjectName',
    dataLoaderParameter: 'DataLoader',
    dataLoaderActionParameter: 'DataLoadAction',
    viewIdParameter: 'ViewId',
    disableSmoothingParameter: 'DisableSmoothing',
    viewNameParameter: 'ViewName',
    editorParameter: 'Editor',
    componentIdParameter: 'ComponentId',
    urlDimensionParameterPrefix: 'Dim',
    urlGroupParameterPrefix: 'Gr',
    urlValueParameterPrefix: 'Val',
    bookmarkIdParameter: 'BookmarkId',
    themeIdParameter: 'ThemeId',
    isPrintParameter: 'print',
    alertMessageIdParameter: 'AlertMessageId',
    alertTypeParameter: 'AlertType',
    documentIdParameter: 'DocumentId',
    documentNameParameter: 'DocumentName',
    localeParameter: 'Locale',
    globalSettingsParameter: 'StudioSettings',
    recentItemsParameter: 'RecentItems',
    layoutSizeParameter: 'LayoutSize',
    browserDataVersion: 'BrowserDataVersion',
    testIdParameter: 'TestId',
    localeDimensionId: 'Locale',

    currentViewsGroupId: '{5ADFDB1A-1B0D-4FE8-B022-CA2DFC343558}',
    currentViewGroupName: 'Current view',
    dimension1: 'Dimension1',
    dimension2: 'Dimension2',
    loginKey: 'Login',
    passwordKey: 'Password',
    logoutPage: 'Logout',
    defaultTooltipFormat: '<From> - <To>',
    defaultLabelFormat: '<Result>',
    percentageNumberFormatName: 'Percent, no decimal',
    numberFormatName: 'Number',
    intervalFormatName: 'Interval',
    numberNoDecimalFormatName: 'Number, no decimal',
    metricDriverDimensionId: '{ED615835-EC48-4C35-B658-BECF3706ACE1}',
    recordDriverDimensionId: '{75F4DAAD-40DC-46E6-ADEB-254470D042B2}',
    timeFieldId: 'b430b809-7c30-4655-a850-4addef07ca97',
    get minDate(): Date {
        return new Date(1900, 0, 1);
    },
    get maxDate(): Date {
        return new Date(3000, 0, 1);
    },
    drillDownToRecordsId: '{A02AB95B-7DD5-4DCD-ACC2-3B5CC29794D4}',
    dbMapperCounterFieldId: '__Count',
    dbMapperCurrentTimeFieldId: '__CurrentTime',
    dbMapperConnectionIdFieldId: '__ConnectionId',
    dbMapperWeightFieldId: '__Weight',

    fromDateQueryParameter: 'FromDate',
    toDateQueryParameter: 'ToDate',

    gestureStartEvent: 'gesturestart',
    gestureChangeEvent: 'gesturechange',
    gestureEndEvent: 'gestureend',

    gridNumberStyleName: 'Grid number style',
    gridHeaderStyleName: 'Grid headers text style',
    gridHeaderHoverStyleName: 'Grid headers text hover style',
    gridTextStyleName: 'Grid text style',

    defaultMenuItemStyle: 'Menu item style',
    defaultMenuItemHoverStyle: 'Menu item hover style',
    defaultMenuItemSelectedStyle: 'Menu item selected style',

    treeLevelStyles: [
        {
            itemDefaultStyle: 'metadata-tree-first-level-default',
            itemHoverStyle: 'metadata-tree-first-level-hover',
            itemSelectedStyle: 'metadata-tree-first-level-select'
        }
    ],
    treeStyles: {
        itemDefaultStyle: 'metadata-tree-default-default',
        itemHoverStyle: 'metadata-tree-default-hover',
        itemSelectedStyle: 'metadata-tree-default-select'
    },
    pointsInInch: 96,

    emptyColor: 'rgba(0, 0, 0, 0)',
    shapeDefaultValueColor: 'rgba(255, 0, 0, 1)',
    shapeFillColor: 'rgba(227, 211, 169, 1)',
    shapeHoverColor: 'rgba(247, 240, 200, 1)',
    shapeStrokeColor: 'rgba(130, 130, 130, 1)',
    shapeStrokeSelectedColor: 'rgba(0, 0, 0, 1)',
    pinDefaultColor: 'rgba(255, 255, 100, 1)',

    gridColors: {
        white: {
            gridColor1: '#E5E8EB',
            gridColor5: '#BDC3C7',
            gridColor10: '#BDC3C7'
        },
        black: {
            gridColor1: '#555555',
            gridColor5: '#55616F',
            gridColor10: '#55616F'
        }
    },

    defaultEmptyDimensionName: strings.defaultEmptyDimensionName,

    regressionTypes: {
        parameter: 'AltoSoft.Insight.DataDefs.Regression.RegressionParameter, AltoSoft.Insight.DataDefs'
    },
    seriesTypes: {
        metric: 'AltoSoft.Insight.DataDefs.Components.MetricSeries, AltoSoft.Insight.DataDefs',
        record: 'AltoSoft.Insight.DataDefs.Components.RecordSeries, AltoSoft.Insight.DataDefs',
        tt: 'AltoSoft.Insight.DataDefs.Components.TTSeries, AltoSoft.Insight.DataDefs',
        processAttribute: 'AltoSoft.Insight.DataDefs.Components.ProcessAttributeSeries, AltoSoft.Insight.DataDefs',
        ttRecord: 'AltoSoft.Insight.DataDefs.Components.TTRecordSeries, AltoSoft.Insight.DataDefs'
    },
    styleTypes: {
        textStyle: 'AltoSoft.Insight.DataDefs.StylesAndThemes.TextStyle, AltoSoft.Insight.DataDefs',
        borderStyle: 'AltoSoft.Insight.DataDefs.StylesAndThemes.BorderStyle, AltoSoft.Insight.DataDefs',
        paletteStyle: 'AltoSoft.Insight.DataDefs.StylesAndThemes.PaletteStyle, AltoSoft.Insight.DataDefs'
    },
    drillDownTypes: {
        time: 'AltoSoft.Insight.DataDefs.Components.TimeDrillDown, AltoSoft.Insight.DataDefs',
        dimension: 'AltoSoft.Insight.DataDefs.Components.DimensionDrillDown, AltoSoft.Insight.DataDefs',
        series: 'AltoSoft.Insight.DataDefs.Components.SeriesDrillDown, AltoSoft.Insight.DataDefs',
        geo: 'AltoSoft.Insight.DataDefs.Components.GeoDrillDown, AltoSoft.Insight.DataDefs',
        metricName: 'AltoSoft.Insight.DataDefs.Components.MetricNameDrillDown, AltoSoft.Insight.DataDefs',
        swimlaneGroup: 'AltoSoft.Insight.DataDefs.Components.SwimlaneGroupDrillDown, AltoSoft.Insight.DataDefs',
        processFilterDefinition: 'AltoSoft.Insight.DataDefs.Components.ProcessFilterDefinitionDrilldown, AltoSoft.Insight.DataDefs'
    },
    swimlaneGroupDrillDownIdTemplate: 'ProcessId_{0}',
    processFilterDefinitionDrillDownIdTemplate: 'ProcessFilterDefinitionId_{0}',
    alertTypes: {
        metric: 'AltoSoft.Insight.DataDefs.Alerts.MetricAlertDocument, AltoSoft.Insight.DataDefs',
        record: 'AltoSoft.Insight.DataDefs.Alerts.RecordAlertDocument, AltoSoft.Insight.DataDefs',
        process: 'AltoSoft.Insight.DataDefs.Alerts.ProcessAlertDocument, AltoSoft.Insight.DataDefs'
    },
    alertMessageTypes: {
        metric: 'AltoSoft.Insight.DataDefs.AlertMessages.MetricAlertMessage, AltoSoft.Insight.DataDefs',
        record: 'AltoSoft.Insight.DataDefs.AlertMessages.RecordAlertMessage, AltoSoft.Insight.DataDefs',
        process: 'AltoSoft.Insight.DataDefs.AlertMessages.ProcessAlertMessage, AltoSoft.Insight.DataDefs',
        notResolvedAlertMessage: 'NotResolvedAlertMessage',
        groupAlertMessage: 'GroupAlertMessage',
        criticalAlertMessage: 'CriticalAlertMessage'
    },
    alertMessageShortTypes: {
        metric: 'MetricAlertMessage',
        record: 'RecordAlertMessage',
        process: 'ProcessAlertMessage'
    },
    customFilterGroupType: 'AltoSoft.Insight.DataDefs.FilterPeerGroupDocument, AltoSoft.Insight.DataDefs',
    processFilterDefinitionType: 'AltoSoft.Insight.DataDefs.Components.Process.ProcessFilterDefinition, AltoSoft.Insight.DataDefs',
    appearanceTypes: {
        metricGrid: 'AltoSoft.Insight.DataDefs.Components.Appearances.MetricGridAppearance, AltoSoft.Insight.DataDefs',
        processGrid: 'AltoSoft.Insight.DataDefs.Components.Appearances.ProcessGridAppearance, AltoSoft.Insight.DataDefs',
        recordGrid: 'AltoSoft.Insight.DataDefs.Components.Appearances.RecordGridAppearance, AltoSoft.Insight.DataDefs',
        grid: 'AltoSoft.Insight.DataDefs.Components.Appearances.GridAppearance, AltoSoft.Insight.DataDefs'
    },
    documentTypes: {
        marker: 'AltoSoft.Insight.DataDefs.AuthenticationCore.MarkerDocument, AltoSoft.Insight.DataDefs',
        bookmark: 'AltoSoft.Insight.DataDefs.BookmarkDocument, AltoSoft.Insight.DataDefs',
        userSettings: 'AltoSoft.Insight.DataDefs.UserSettings, AltoSoft.Insight.DataDefs'
    },
    userSettingsTypeName: 'UserSettings',
    drillDownIdentifierType: 'AltoSoft.Insight.Common.DataService.DrillDownIdentifier, AltoSoft.Insight.DataDefs',
    adminDocumentTypes: {
        projectDocument: 'ProjectDefinition',
        userDocument: 'InsightUser',
        roleDocument: 'Role',
        applicationSettings: 'ApplicationSettings',
        userMappingTab: 'UserMappingsObject',
        calendar: 'CalendarObject',
        financialYearDocument: 'FinancialYear',
        sharedConnectionDocument: Connection.category,
        filterDocument: 'Filter',
        logsTab: 'LogSettingsInfo',
        optionsTab: 'optionsTab',
        distributionTab: 'DistributionOptions',
        licenseManagerTab: 'licenseManagerTab',
        licenseSettings: 'licenseSettings',
        filterGroupDocument: 'filterGroupDocument',
        adminDashboard: 'AdminDashboard',
        sqlFunctionDocument: 'SQLFunctionDocument',
        externalProgram: 'ExternalProgram'
    },
    themeManagerDocumentTypes: {
        themeDocument: 'DashboardTheme',
        dateFormatDocument: 'DateTimeFormat',
        formatDocument: 'Format',
        tooltipDocument: 'TooltipFormat',
        viewLayout: 'ViewLayout'
    },
    dataloadDocumentTypes: {
        executionPlansEditor: 'ExecutionPlansEditor',
        loadConsoleEditor: 'LoadConsoleEditor',
        recordDates: 'RecordDates',
        schedulerLogEditor: 'SchedulerLogEditor',
        statisticsEditor: 'StatisticsEditor'
    },
    studioDocumentTypes: {
        view: 'ViewComponent',
        record: 'RecordDocument',
        rModel: 'RModel',
        rFunction: 'RFunction',
        standardMetric: 'MetricStandard',
        metricPool: 'MetricPool',
        processMetric: 'ProcessMetric',
        derivedMetric: 'DerivedMetric',
        forecastMetric: 'ForecastMetric',
        metricGroup: 'MetricGroupDocument',
        regressionMetric: 'RegressionMetric',
        metric: 'Metric',
        translationTable: 'TranslationTable',
        staticTranslationTable: 'StaticTranslationTable',
        recordGraph: 'TODO: set record graph document type',
        expressionEditor: 'TODO: set expression editor document type',
        dataSource: 'DataSource' as const,
        fileProviderItem: 'fileProviderItem',
        fileProviderTemplate: 'ParsingTemplateDS',
        fileProviderJob: 'JobDS',
        fileProviderBatch: 'BatchDS',
        fileProviderServer: 'ServerDS',
        fileProviderTask: 'TaskDS',
        fileProviderJobLog: 'JobLogDS',
        fileProviderFTPLog: 'FTPLog',
        fileProviderManJob: 'ManualJob',
        report: 'ReportSchedule',
        executionPlan: 'ExecutionPlan',
        process: 'Process',
        dataLoadModule: 'DataLoadModule',
        guide: 'Guide',
        audit: 'Audit',
        olapDocument: 'OlapDocument',
        geoData: 'GeoDatabaseDocument',
        webService: 'WebServiceDocument',
        testCase: 'TestCase',
        projectTest: 'ProjectTest',
        testSession: 'TestRunSession'
    },
    mgType: 'AltoSoft.Insight.DataDefs.Components.ServiceInterface.MgSettingDefinition, AltoSoft.Insight.DataDefs',
    viewComponentType: 'ViewComponent',
    viewAppearanceType: 'ViewAppearance',
    driverGroupType: 'AltoSoft.Insight.DataDefs.AuthenticationCore.DriverGroup, AltoSoft.Insight.DataDefs',
    reportScheduleType: 'AltoSoft.Insight.DataDefs.Reports.ReportSchedule,AltoSoft.Insight.DataDefs',
    sapVariableType: 'AltoSoft.Insight.DBCore.Sap.SapVariable, AltoSoft.Insight.DBCore',

    mathExpressionTypes: {
        queryParameter: 'AltoSoft.Insight.DataDefs.EngineStorageSchema.ExternalData.CustomQueryParameter, AltoSoft.Insight.DataDefs',
        caseValue: 'AltoSoft.Insight.DataDefs.KPITypeData.Statements.CaseValue, AltoSoft.Insight.DataDefs',
        processStepsListExpression: 'ProcessStepsListExpression',
        swimlaneGroup: 'swimlaneGroup'
    },

    fileTypes: {
        excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xlsx, .xls',
        csv: 'text/csv, application/vnd.ms-excel, .csv, .txt',
        zip: 'application/zip, application/x-zip-compressed',
        xml: 'application/xml, text/xml'
    },

    driverDefaultStyle: {
        contentStyle: 'driver-content',
        itemDefaultStyle: 'driver-item-default',
        itemHoverStyle: 'driver-item-hover',
        itemSelectedStyle: 'driver-item-select',
        itemOpenedStyle: 'driver-item-opened',
        itemDefaultBorderStyle: 'driver-item-border-default',
        itemHoverBorderStyle: 'driver-item-border-hover',
        itemSelectedBorderStyle: 'driver-item-border-select',
        itemOpenedBorderStyle: 'driver-item-border-opened'
    },

    tabDefaultStyle: {
        itemDefaultStyle: 'tab-item-default',
        itemHoverStyle: 'tab-item-hover',
        itemSelectedStyle: 'tab-item-select'
    },

    bookmarkType: '',

    commands: {
        projectMode: 'ProjectMode',
        newDocument: 'NewDocument',
        save: 'Save',
        saveAs: 'SaveAs',
        saveAll: 'SaveAll',
        recentItems: 'RecentItems',
        open: 'OpenDocument',
        rename: 'Rename',
        deleteDocument: 'Delete',
        close: 'Close',
        closeAll: 'CloseAll',
        changePassword: 'ChangePassword',
        logout: 'Logout',

        about: 'About',
        help: 'Help',

        moveLeft: 'MoveLeft',
        moveRight: 'MoveRight',
        moveTop: 'MoveTop',
        moveBottom: 'MoveBottom',

        resizeWLeft: 'ResizeWLeft',
        resizeWRight: 'ResizeWRight',
        resizeELeft: 'ResizeELeft',
        resizeERight: 'ResizeERight',
        resizeNTop: 'ResizeNTop',
        resizeNBottom: 'ResizeNBottom',
        resizeSTop: 'ResizeSTop',
        resizeSBottom: 'ResizeSBottom',

        copy: 'Copy',
        paste: 'Paste',

        showAnchors: 'ShowAnchors',
        deleteAllAnchors: 'DeleteAllAnchors',
        deleteComponents: 'DeleteComponents',
        autoAnchors: 'AutoAnchors',
        snapToGrid: 'SnapToGrid',
        blackCanvas: 'BlackCanvas',
        sendToBack: 'SendToBack',
        bringToFront: 'BringToFront',
        reorderHorizontal: 'ReorderHorizontal',
        reorderVertical: 'ReorderVertical',

        importProjectDocuments: 'Import',
        createSubProcess: 'Create subprocess',
        deleteSubProcess: 'Delete subprocess',
        exportProjectDocuments: 'Export',
        exportProjectDocumentsToSourceFolder: 'ExportToSourceFolder',
        updateAllProjects: 'Update all projects',
        importSolutions: 'Import solutions',
        studioSettings: 'StudioSettings',
        filterGroups: 'FilterGroups',

        editComponent: 'EditComponent',

        specifiedColors: 'specifiedColors',

        openInViewer: 'openInViewer',
        preview: 'preview',

        dataWizard: 'ComponentData',
        timeWizard: 'ComponentTime',
        displayWizard: 'ComponentDisplayOptions',
        actionWizard: 'ComponentActions',

        undo: 'Undo',
        redo: 'Redo',

        refreshEditor: 'refreshEditor',
        reloadProject: 'reloadProject',

        clearAll: 'ClearAll',

        publish: 'Publish',
        publishAndRebuild: 'PublishAndRebuild',
        zoom: 'Zoom',

        generateLocalizationTables: 'GenerateLocalizationTables',
        schedule: 'schedule',
        unschedule: 'unschedule',
        refreshDataLoads: 'refreshDataLoads',
        cancelDataLoads: 'cancelDataLoads',
        resumeDataLoads: 'resumeDataLoads',
        refreshRecordDates: 'refreshRecordDates',
        addRecordDate: 'addRecordDate',
        removeSelectedDate: 'removeSelectedDate',
        refreshSchedulerLog: 'refreshSchedulerLog',
        startSchedulerLog: 'startSchedulerLog',
        stopSchedulerLog: 'stopSchedulerLog',
        turnOnEditMode: 'turnOnEditMode',
        turnOffEditMode: 'turnOffEditMode',
        getLogs: 'getLogs',
        resaveAll: 'resaveAll',
        fixReferences: 'fixReferences',
        editTheme: 'editTheme',
        openDataLoadModule: 'openDataLoadModule',
        changeViewLayout: 'changeViewLayout',
        toggleTestSession: 'toggleTestSession',
        tenantsUpdate: 'tenantsUpdate',
        tenantsUpgrade: 'tenantsUpgrade',
        generateRModel: 'generateRModel',
        openDimensionManager: 'openDimensionManager',
        showUsages: 'showUsages'
    },

    process: {
        stepsDBPostfix: '_Steps',
        violator: 'Violator',
        isFinished: 'IsFinished',
        creationTime: 'CreationTime',
        lastModificationTime: 'LastModificationTime',
        currentState: 'CurrentStep',
        defaultStepSize: {
            x: 120,
            y: 40
        }
    },

    iOSDateFormat: 'yyyy-MM-ddTHH:mm:ss',
    iOSTimeFormat: 'HH:mm:ss',

    componentGroups: {
        chartComponents: 'ChartComponents',
        gridComponents: 'GridComponents',
        processComponents: 'ProcessComponents',
        driverComponents: 'DriverComponents',
        uiComponents: 'UIComponents',
        controlComponents: 'Controls',
        otherComponents: 'OtherComponents'
    } as const,

    translationTable: {
        itemIdKey: 'Item Id',
        nameKey: 'Name'
    },

    recentOpenedDocumentsCount: 10,
    zoomItems: [10, 25, 50, 75, 100, 150, 200, 500],

    undoChainLength: 100,

    geoLayers: {
        labelsLayerId: '2b50fb56-322f-4d58-bd5e-cf4737f4e86a',
        citiesLayerId: 'e9a996ff-1b35-49cc-8f5f-21e1d1fb4284',
        zipCodesLayerId: 'a6c12275-e816-4273-adc3-3be275a77193',
        countriesLayerId: 'a6f9e37b-3341-4594-a28e-54406b47043c',
        countiesLayerId: '8805d722-013e-4a3f-baa1-6913bd4c9f47',
        statesLayerId: '5c4ca07d-5f1c-424f-89c9-6e606dfbd46e',
        baseMapLayerId: '1d63b498-83a4-408d-9535-386a780f8df2'
    },

    knownVirtualProcessVariables: {
        violator: { id: 'e469db6a-9b84-4c33-b503-eff7eeca806d', value: 'Violator' },
        lastModificationTime: { id: '6fedf702-307a-44d1-9ae6-5714d45bb0c3', value: 'LastModificationTime' },
        creationTime: { id: 'e02cbefb-1a95-41d8-8846-fa6d78fad74c', value: 'CreationTime' },
        currentState: { id: 'c16b98a1-c7f2-4439-9b5f-d8c5cb71907f', value: 'CurrentStep' },
        isFinished: { id: '93515272-66a2-47b3-ac98-9aa6cf9b4d68', value: 'IsFinished' }
    },

    textTemplateTypes: {
        customProperties: 'CustomProperties',
        timeFilter: 'TimeFilter',
        filter: 'Filter',
        record: 'Record',
        metric: 'Metric'
    },

    textTemplateProperties: {
        filterValues: 'Filter values',
        startDate: 'Start date',
        endDate: 'End date'
    },

    textTemplateCustomProperties: {
        userName: 'User name',
        currentDate: 'Current date',
        insightVersionProperty: 'Insight version',
        analyticProjectVersionProperty: 'Insight project version',
        analyticProjectNameProperty: 'Insight project display name',
        clientTimeOffset: 'Client offset'
    },

    dataLoadCategory: 'Dataload',

    quickSearchItems: {
        projects: { name: strings.documentFactory.projects, categories: ['ProjectDefinition'] },
        connection: { name: strings.documentFactory.adminConnection, categories: ['Connection'] },
        users: { name: strings.documentFactory.users, categories: ['InsightUser'] },
        roles: { name: strings.documentFactory.roles, categories: ['Role'] },
        filters: { name: strings.documentFactory.filters, categories: ['Filter'] }
    },

    providerType: {
        sql: { id: 'sql', value: 'Sql server Provider' },
        odbc: { id: 'odbc', value: 'Odbc Provider' },
        oledb: { id: 'oledb', value: 'OleDb Provider' },
        dsn: { id: 'dsn', value: 'DSN Provider' },
        mySql: { id: 'cn', value: 'Connector/Net' },
        odp: { id: 'odp', value: 'ODP.NET Provider' },
        db2: { id: 'DB2', value: 'DB2.NET Provider' },
        ws: { id: 'WS', value: 'Web Service' },
        oDataNet: { id: 'oDataNet', value: 'OData .NET' },
        svc: { id: 'SVC', value: 'WPF Service' },
        olap: { id: 'OLAP', value: 'ADOMD' },
        cache: { id: 'CACHE', value: 'Cache.NET Provider' },
        wsOlap: { id: 'ws for olap', value: 'Ws for OLAP' },
        file: { id: 'File', value: 'CSV file provider' }
    },

    connectionConstants: {
        provider: 'Provider',
        host: 'Host',
        databaseName: 'Database',
        user: 'User',
        password: 'Password',
        application: 'App',
        port: 'Port',
        useWindowsAuthentication: 'UseWindowsAuthentication',
        file: 'File',
        connectionString: 'connectionString'
    },

    textEditorCommands: {
        bold: 'bold',
        italic: 'italic',
        underline: 'underline',
        justifyleft: 'justifyleft',
        justifycenter: 'justifycenter',
        justifyright: 'justifyright',
        justifyblock: 'justifyblock',
        fontSize: 'fontSize',
        fontFamily: 'fontName',
        foreColor: 'foreColor',
        link: 'createlink',
        table: 'table',
        template: 'template',
        style: 'style',
        borderStyle: 'borderStyle',
        insertimage: 'insertimage'
    },

    keyCodes: {
        BACKSPACE: 8,
        TAB: 9,
        ENTER: 13,
        SHIFT: 16,
        CTRL: 17,
        ALT: 18,
        PAUSE: 19,
        CAPS_LOCK: 20,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT_ARROW: 37,
        UP_ARROW: 38,
        RIGHT_ARROW: 39,
        DOWN_ARROW: 40,
        INSERT: 45,
        DELETE: 46,
        KEY_0: 48,
        KEY_1: 49,
        KEY_2: 50,
        KEY_3: 51,
        KEY_4: 52,
        KEY_5: 53,
        KEY_6: 54,
        KEY_7: 55,
        KEY_8: 56,
        KEY_9: 57,
        KEY_SEMICOLON: 59,
        KEY_EQUALS: 61,
        KEY_A: 65,
        KEY_B: 66,
        KEY_C: 67,
        KEY_D: 68,
        KEY_E: 69,
        KEY_F: 70,
        KEY_G: 71,
        KEY_H: 72,
        KEY_I: 73,
        KEY_J: 74,
        KEY_K: 75,
        KEY_L: 76,
        KEY_M: 77,
        KEY_N: 78,
        KEY_O: 79,
        KEY_P: 80,
        KEY_Q: 81,
        KEY_R: 82,
        KEY_S: 83,
        KEY_T: 84,
        KEY_U: 85,
        KEY_V: 86,
        KEY_W: 87,
        KEY_X: 88,
        KEY_Y: 89,
        KEY_Z: 90,
        LEFT_META: 91,
        RIGHT_META: 92,
        SELECT: 93,
        NUMPAD_0: 96,
        NUMPAD_1: 97,
        NUMPAD_2: 98,
        NUMPAD_3: 99,
        NUMPAD_4: 100,
        NUMPAD_5: 101,
        NUMPAD_6: 102,
        NUMPAD_7: 103,
        NUMPAD_8: 104,
        NUMPAD_9: 105,
        MULTIPLY: 106,
        ADD: 107,
        SUBTRACT: 109,
        DECIMAL: 110,
        DIVIDE: 111,
        F1: 112,
        F2: 113,
        F3: 114,
        F4: 115,
        F5: 116,
        F6: 117,
        F7: 118,
        F8: 119,
        F9: 120,
        F10: 121,
        F11: 122,
        F12: 123,
        NUM_LOCK: 144,
        SCROLL_LOCK: 145,
        MINUS: 173,
        SEMICOLON: 186,
        EQUALS: 187,
        COMMA: 188,
        DASH: 189,
        PERIOD: 190,
        FORWARD_SLASH: 191,
        GRAVE_ACCENT: 192,
        OPEN_BRACKET: 219,
        BACK_SLASH: 220,
        CLOSE_BRACKET: 221,
        SINGLE_QUOTE: 222
    },
    ifThenElseFunctionId: 'If-then-else',
    argumentIf: 'if',
    argumentThen: 'then',
    argumentElse: 'else',
    subprocessDurationFunction: 'Subprocess Duration',
    subprocessDurationInSecondsFunction: 'Subprocess Duration in seconds',
    subprocessDurationFunctionArgument: 'interval',
    medianFunction: 'Median',
    medianFunctionArgument: 'expr',
    percentileFunction: 'Percentile',
    percentileFunctionArgument: 'percent',
    dateDiffBusinessFunction: 'DATE_DIFF_BUSINESS',
    dateDiffBusinessFunctionDate1Argument: 'StartDate',
    dateDiffBusinessFunctionDate2Argument: 'EndDate',
    dateAddBusinessFunction: 'DATE_ADD_BUSINESS',
    dateAddBusinessFunctionNumberArgument: 'Number',
    dateAddBusinessFunctionDateArgument: 'Date',
    isBusinessDateFunction: 'IS_BUSINESS',
    isBusinessDateFunctionDateArgument: 'Date',
    calendarNameArgument: 'calendar',
    nullTokenName: 'NULL',
    filterIsReopenedTokenName: 'IsReopened',
    argumentIsReopened: 'value',
    filterMisingStepsTokenName: 'MissingSteps',
    filterStepExistsTokenName: 'StepExists',
    filterTransitionBetweenStepsAtLeastTokenName: 'TransitionBetweenStepsAtLeast',
    filterTransitionBetweenStepsAtMostTokenName: 'TransitionBetweenStepsAtMost',
    filterSwimlanesTokenName: 'SwimlaneGroups',
    argumentReopened: 'reopened',
    filterPatternTokenName: 'Pattern',
    whereInTokenName: 'WHERE_IN',
    whereNotInTokenName: 'WHERE_NOT_IN',
    fromDateWithTimezoneTokenName: 'FromDateWithTimezone',
    toDateWithTimezoneTokenName: 'ToDateWithTimezone',
    argumentValues: 'values',
    argumentExpression: 'expr',
    argumentSteps: 'steps',
    argumentStep: 'step',
    argumentCount: 'count',
    argumentFromStep: 'fromStep',
    argumentToStep: 'toStep',
    argumentIntervalCount: 'intervalCount',
    argumentIntervalType: 'intervalType',
    argumentSwimlaneGroups: 'swimlaneGroups',
    rFunctionTokenDataArgument: 'data_frame',

    notificationType: {
        none: 'None',
        success: 'Success',
        failure: 'Failure'
    },

    rebuildIndexesMode: {
        rebuildAll: 'RebuildAll',
        dontRebuild: 'DontRebuild',
        useRecordSettings: 'UseRecordSettings'
    },

    processDefinitionTypes: {
        count: 'AltoSoft.Insight.DataDefs.DocumentModels.ProcessCountDefinition, AltoSoft.Insight.DataDefs',
        ratio: 'AltoSoft.Insight.DataDefs.DocumentModels.ProcessRatioDefinition, AltoSoft.Insight.DataDefs',
        timing: 'AltoSoft.Insight.DataDefs.DocumentModels.ProcessTimingDefinition, AltoSoft.Insight.DataDefs',
        queue: 'AltoSoft.Insight.DataDefs.DocumentModels.ProcessQueueDefinition, AltoSoft.Insight.DataDefs'
    },
    processKnownFields: {
        violatorKey: 'Violator',
        isFinishedKey: 'IsFinished',
        creationTimeKey: 'CreationTime',
        lastModificationTimeKey: 'LastModificationTime',
        currentStepKey: 'CurrentStep'
    },

    documentDescriptorType: 'AltoSoft.Insight.Common.RepositoryInterfaces.DocumentDescriptor, AltoSoft.Insight.Common',

    defaultFormats: {
        number: { id: '901d7582-5356-46ef-8ddb-d830704e68f1', name: 'Number', value: '#,##0.00' },
        numberNoDecimal: { id: 'd494b7d2-5913-4dc0-84ff-a8066567b759', name: 'Number, no decimal', value: '#,##0' },
        currency: { id: 'bf6694dd-6710-48d0-948e-83952c4a7c24', name: 'Currency', value: '"$"#,##0.00' },
        currencyNoCents: {
            id: '6eb8ddc5-2728-4396-b217-e506c71cced6',
            name: 'Currency, no cents',
            value: '"$"#,##0'
        },
        currencyInMillions: {
            id: 'ab7609f6-4456-4197-8310-a3a23ab89bfe',
            name: 'Currency, in millions',
            value: '"$"#,##0,,.000"M"'
        },
        currencyInBillions: {
            id: 'f70db128-93fa-4357-b28a-bc0d9e0dca12',
            name: 'Currency, in billions',
            value: '"$"#,##0,,,.0"B"'
        }
    },

    descriptorConstants: {
        defaultComponentWidth: 400,
        defaultComponentHeight: 300,
        defaultDriverWidth: 250,
        defaultDriverHeight: 30
    },

    highchartTypes: {
        area: 'area',
        arearange: 'arearange',
        areaspline: 'areaspline',
        areasplinerange: 'areasplinerange',
        bubble: 'bubble',
        column: 'column',
        candlestick: 'candlestick',
        ohlc: 'ohlc',
        dialGauge: 'gauge',
        line: 'line',
        linearGauge: 'linearGauge',
        pie: 'pie',
        spline: 'spline',
        treemap: 'treemap',
        scatter: 'scatter',
        mirrorrange: 'mirrorrange',
        columnrange: 'columnrange',
        waterfall: 'waterfall',
        pyramid: 'pyramid',
        funnel: 'funnel',
        boxPlot: 'boxplot'
    },

    viewSectionId: 'c2a45932-6fc8-49f9-81cd-bf642f52d707',

    createLifecycle: {
        OnSystemStart: strings.createLifecycle.OnSystemStart,
        OnBatchStart: strings.createLifecycle.OnBatchStart,
        OnFirstUse: strings.createLifecycle.OnFirstUse
    },

    updateLifecycle: {
        OnNewKey: strings.updateLifecycle.OnNewKey,
        Never: strings.updateLifecycle.Never,
        NotExecute: strings.updateLifecycle.NotExecute
    },

    expireLifeCycle: {
        Never: strings.expireLifeCycle.Never,
        AfterUse: strings.expireLifeCycle.AfterUse,
        OnBatchEnd: strings.expireLifeCycle.AfterUse
    },
    documentReferenceTypes: {
        autoMetric: 'AltoSoft.Insight.DataDefs.DocumentModels.AutoMetricReference, AltoSoft.Insight.DataDefs',
        metric:
            'AltoSoft.Insight.Common.RepositoryInterfaces.DocumentReference`1[[AltoSoft.Insight.DataDefs.DocumentModels.Metric, AltoSoft.Insight.DataDefs]], AltoSoft.Insight.Common',
        slaveDocument:
            'AltoSoft.Insight.Common.RepositoryInterfaces.SlaveDocumentReference`2[[AltoSoft.Insight.DataDefs.DocumentModels.Metric, AltoSoft.Insight.DataDefs], [AltoSoft.Insight.DataDefs.DocumentModels.MetricPool, AltoSoft.Insight.DataDefs]], AltoSoft.Insight.Common',
        metricGroup:
            'AltoSoft.Insight.Common.RepositoryInterfaces.DocumentReference`1[[AltoSoft.Insight.DataDefs.MetricGroup.MetricGroupDocument, AltoSoft.Insight.DataDefs]], AltoSoft.Insight.Common',
        dataSource:
            'AltoSoft.Insight.Common.RepositoryInterfaces.DocumentReference`1[[AltoSoft.Insight.DataDefs.DocumentModels.DataSource, AltoSoft.Insight.DataDefs]], AltoSoft.Insight.Common',
        executionPlan:
            'AltoSoft.Insight.Common.RepositoryInterfaces.DocumentReference`1[[AltoSoft.Insight.DataDefs.Adapter.ExecutionPlan, AltoSoft.Insight.DataDefs]], AltoSoft.Insight.Common',
        standartMetric:
            'AltoSoft.Insight.Common.RepositoryInterfaces.DocumentReference`1[[AltoSoft.Insight.DataDefs.DocumentModels.StandardMetric, AltoSoft.Insight.DataDefs]], AltoSoft.Insight.Common',
        metricStandart:
            'AltoSoft.Insight.Common.RepositoryInterfaces.DocumentReference`1[[AltoSoft.Insight.DataDefs.DocumentModels.StandardMetric, AltoSoft.Insight.DataDefs]], AltoSoft.Insight.Common',
        record:
            'AltoSoft.Insight.Common.RepositoryInterfaces.DocumentReference`1[[AltoSoft.Insight.DataDefs.DocumentModels.RecordDocument, AltoSoft.Insight.DataDefs]], AltoSoft.Insight.Common',
        tt:
            'AltoSoft.Insight.Common.RepositoryInterfaces.DocumentReference`1[[AltoSoft.Insight.DataDefs.DocumentModels.TranslationTable, AltoSoft.Insight.DataDefs]], AltoSoft.Insight.Common',
        parameter:
            'AltoSoft.Insight.Common.RepositoryInterfaces.DocumentReference`1[[AltoSoft.Insight.DataDefs.CalculationParameters.Parameter, AltoSoft.Insight.DataDefs]], AltoSoft.Insight.Common',
        report:
            'AltoSoft.Insight.Common.RepositoryInterfaces.DocumentReference`1[[AltoSoft.Insight.DataDefs.Reports.ReportSchedule, AltoSoft.Insight.DataDefs]], AltoSoft.Insight.Common',
        process:
            'AltoSoft.Insight.Common.RepositoryInterfaces.DocumentReference`1[[AltoSoft.Insight.DataDefs.Process.Process, AltoSoft.Insight.DataDefs]], AltoSoft.Insight.Common',
        processFilterDefinition:
            'AltoSoft.Insight.Common.RepositoryInterfaces.DocumentReference`1[[AltoSoft.Insight.DataDefs.Components.Process.ProcessFilterDefinition, AltoSoft.Insight.DataDefs]], AltoSoft.Insight.Common'
    },

    testDBMappingControl: {
        testStatusRequestTimeout: 1000
    },

    aggregationFunctions: {
        sum: 'SUM',
        avg: 'AVG',
        count: 'COUNT',
        countAll: 'COUNT(*)',
        countUnique: 'COUNT_UNIQUE',
        min: 'MIN',
        max: 'MAX',
        stdev: 'STDEV'
    },

    doNotShowTableChangesParameter: 'DoNotShowTableChanges',

    applicationNames: {
        admin: 'Admin',
        themeManager: 'Themes',
        studio: 'Studio',
        dataLoadManager: 'DataLoad',
        viewer: 'View'
    },
    queryOrder: {
        asc: 'ASC',
        desc: 'DESC',
        none: 'NONE'
    },
    urlValidationPattern: /^((ht|f)tps?:\/\/[^\/]|\\{2}[^\\]|\/{1}[^\/]).*$/i,
    startTemplateCharacter: '[',
    middleTemplateCharacter: '::',
    endTemplateCharacter: ']',
    urlHasTemplatesPattern: /\[[^::]+::[^::]+::[^\]]+\]/i,
    emailValidationPattern: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    pinIcons: {
        pin_blue: 'pin_blue.png',
        pin_green: 'pin_green.png',
        pin_grey: 'pin_grey.png',
        pin_red: 'pin_red.png',
        pin_yellow: 'pin_yellow.png'
    },
    defaultAxisMinValue: 0,
    defaultAxisMaxValue: 100,
    defaultAxisStep: 10,

    mainMenu: {
        admin: 'Admin',
        themeManager: 'Themes and Formats',
        studio: 'Studio',
        dataLoader: 'Data Loader'
    },

    filterTypeOption: {
        processFilter: 'ProcessFilter' as 'ProcessFilter',
        parameterFilter: 'ParameterFilter' as 'ParameterFilter',
        searchPanel: 'SearchPanel' as 'SearchPanel'
    },

    historyItemDefaultConnection: 'Default',
    excelFileTypes: ['xlsx', 'xls'],

    defaultChartPalette: [
        '#57BEC7',
        '#F3C110',
        '#B5D045',
        '#FB8335',
        '#F47EBD',
        '#81B0C5',
        '#E0C7A8',
        '#E24B75',
        '#798287',
        '#B3ECBF',
        '#C7DAD4',
        '#EFEF00',
        '#06397F',
        '#8767A6',
        '#D7615F',
        '#512B45',
        '#435E69',
        '#ED4035',
        '#31ADED',
        '#1D2F43',
        '#0AA594',
        '#CDCD7F',
        '#61D8EE',
        '#F7D4E0',
        '#0063AF',
        '#CAF562',
        '#7F97FF',
        '#FF9C7E',
        '#62F5C8',
        '#DB286B',
        '#93B18F',
        '#CDA93C',
        '#008684',
        '#BB3333',
        '#333399',
        '#8CFF66',
        '#4390D0',
        '#6DA857',
        '#DEB7E4',
        '#82B1B1',
        '#DD9056',
        '#956D88',
        '#4F483D',
        '#BDB7AD',
        '#667788',
        '#A9F7EF',
        '#CDB356',
        '#1F703C',
        '#BBCCEE',
        '#57B058',
        '#9F0000',
        '#33CC00',
        '#876E4F',
        '#FF4614',
        '#98D093',
        '#F0B1AC',
        '#0BC543',
        '#5969BA',
        '#FFE069',
        '#6C2A6A',
        '#0EEFAA',
        '#FFAA66',
        '#819D06',
        '#D7EAAE'
    ],

    olap: {
        measuresKey: 'Measures',
        dimensionKey: 'Dimensions'
    },

    helpSettings: {
        hostedUrl: 'https://docshield.kofax.com/Insight/{0}/6.5.0-55oo6u6oqu/help/',
        supportedLocales: { ja: 'ja_JA' }, //  mapping insight locale to the help locale
        defaultLocale: 'en_US',
        offlineFolder: 'Documentation/{0}/help/',
        sutioApplication: 'Insight_Studio'
    },

    contextHelpIds,

    nationalLettersEquivalents: [
        {
            base: 'A',
            letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
        },
        { base: 'AA', letters: /[\uA732]/g },
        { base: 'AE', letters: /[\u00C4\u00C6\u01FC\u01E2]/g },
        { base: 'AO', letters: /[\uA734]/g },
        { base: 'AU', letters: /[\uA736]/g },
        { base: 'AV', letters: /[\uA738\uA73A]/g },
        { base: 'AY', letters: /[\uA73C]/g },
        { base: 'B', letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g },
        { base: 'C', letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g },
        {
            base: 'D',
            letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
        },
        { base: 'DZ', letters: /[\u01F1\u01C4]/g },
        { base: 'Dz', letters: /[\u01F2\u01C5]/g },
        {
            base: 'E',
            letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
        },
        { base: 'F', letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g },
        {
            base: 'G',
            letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
        },
        {
            base: 'H',
            letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
        },
        {
            base: 'I',
            letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
        },
        { base: 'J', letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g },
        {
            base: 'K',
            letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
        },
        {
            base: 'L',
            letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
        },
        { base: 'LJ', letters: /[\u01C7]/g },
        { base: 'Lj', letters: /[\u01C8]/g },
        { base: 'M', letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g },
        {
            base: 'N',
            letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
        },
        { base: 'NJ', letters: /[\u01CA]/g },
        { base: 'Nj', letters: /[\u01CB]/g },
        {
            base: 'O',
            letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
        },
        { base: 'OE', letters: /[\u00D6\u0152]/g },
        { base: 'OI', letters: /[\u01A2]/g },
        { base: 'OO', letters: /[\uA74E]/g },
        { base: 'OU', letters: /[\u0222]/g },
        { base: 'P', letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g },
        { base: 'Q', letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g },
        {
            base: 'R',
            letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
        },
        {
            base: 'S',
            letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
        },
        {
            base: 'T',
            letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
        },
        { base: 'TZ', letters: /[\uA728]/g },
        {
            base: 'U',
            letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
        },
        { base: 'UE', letters: /[\u00DC]/g },
        { base: 'V', letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g },
        { base: 'VY', letters: /[\uA760]/g },
        { base: 'W', letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g },
        { base: 'X', letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g },
        {
            base: 'Y',
            letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
        },
        {
            base: 'Z',
            letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
        },
        {
            base: 'a',
            letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
        },
        { base: 'aa', letters: /[\uA733]/g },
        { base: 'ae', letters: /[\u00E4\u00E6\u01FD\u01E3]/g },
        { base: 'ao', letters: /[\uA735]/g },
        { base: 'au', letters: /[\uA737]/g },
        { base: 'av', letters: /[\uA739\uA73B]/g },
        { base: 'ay', letters: /[\uA73D]/g },
        { base: 'b', letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g },
        { base: 'c', letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g },
        {
            base: 'd',
            letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
        },
        { base: 'dz', letters: /[\u01F3\u01C6]/g },
        {
            base: 'e',
            letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
        },
        { base: 'f', letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g },
        {
            base: 'g',
            letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
        },
        {
            base: 'h',
            letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
        },
        { base: 'hv', letters: /[\u0195]/g },
        {
            base: 'i',
            letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
        },
        { base: 'j', letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g },
        {
            base: 'k',
            letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
        },
        {
            base: 'l',
            letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
        },
        { base: 'lj', letters: /[\u01C9]/g },
        { base: 'm', letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g },
        {
            base: 'n',
            letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
        },
        { base: 'nj', letters: /[\u01CC]/g },
        {
            base: 'o',
            letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
        },
        { base: 'oe', letters: /[\u00F6\u0153]/g },
        { base: 'oi', letters: /[\u01A3]/g },
        { base: 'ou', letters: /[\u0223]/g },
        { base: 'oo', letters: /[\uA74F]/g },
        { base: 'p', letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g },
        { base: 'q', letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g },
        {
            base: 'r',
            letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
        },
        {
            base: 's',
            letters: /[\u0073\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
        },
        { base: 'ss', letters: /[\u00DF]/g },
        {
            base: 't',
            letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
        },
        { base: 'tz', letters: /[\uA729]/g },
        {
            base: 'u',
            letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
        },
        { base: 'ue', letters: /[\u00FC]/g },
        { base: 'v', letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g },
        { base: 'vy', letters: /[\uA761]/g },
        { base: 'w', letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g },
        { base: 'x', letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g },
        {
            base: 'y',
            letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
        },
        {
            base: 'z',
            letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
        }
    ],
    colors: {
        black: '#000000',
        white: '#FFFFFF',
        gray1: '#292929',
        gray2: '#38434F',
        gray3: '#8D99A1',
        gray4: '#BDC3C7',
        gray5: '#E5E8EB',
        gray6: '#F5F6F7',
        blue: '#1E72B7',
        blue2: '#1F8DCD',
        blue3: '#E5F3FB',
        yellow: '#FFCC05',
        yellow2: '#FFF7DA',
        orange: '#ED8223',
        red: '#F05A58',
        red2: '#FDEEEE',
        green: '#04A598',
        green2: '#E5F6F4'
    },
    metricSectionCategories: [
        documentCategories.metric,
        documentCategories.metricPool,
        documentCategories.metricDerived,
        documentCategories.metricStandard,
        documentCategories.metricProcess,
        documentCategories.olapMetric,
        documentCategories.metricGroup,
        documentCategories.metricRegression
    ] as string[],
    timeIntervalValues: {
        [TimeInterval.second1]: 2,
        [TimeInterval.minute1]: 4,
        [TimeInterval.hour1]: 8,
        [TimeInterval.day1]: 12,
        [TimeInterval.week1]: 13,
        [TimeInterval.month1]: 14,
        [TimeInterval.quarter1]: 15,
        [TimeInterval.year1]: 16
    },
    expressionEditor: {
        userFiltersGroupId: 'userFilterGroup'
    }
};

export default constants;
